/**
 * Mantém somente caracteres que podem ser enviados como texto para ESC/POS.
 * Caracteres de controle e Unicode invisível não podem chegar à impressora,
 * pois alguns modelos os interpretam como comandos de posicionamento.
 */
export function sanitizarTextoParaEscPos(valor: unknown): string {
    const textoSemAcentos = String(valor ?? '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/ç/g, 'c')
        .replace(/Ç/g, 'C');

    return Array.from(textoSemAcentos)
        .map((caractere) => {
            if (/\s/.test(caractere)) return ' ';

            const codigo = caractere.charCodeAt(0);
            return codigo >= 0x20 && codigo <= 0x7E ? caractere : '';
        })
        .join('')
        .replace(/\s+/g, ' ')
        .trim();
}
